import { NSARouterMakerResult } from "namirasoft-account-react";
import { MemoryInputRow, MemoryRow } from "namirasoft-inference";
import { NSBox, NSBoxString, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import InferencerCommonFields from "../components/InferencerCommonFields";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface MemoryEditPageProps extends NSARouterMakerResult, InferenceRouterProps
{
    isEdit: boolean;
}

export default class MemoryEditPage extends Component<MemoryEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    InferencerCommonFields_Ids = createRef<InferencerCommonFields>();
    NSBoxString_Description = createRef<NSBoxString>();

    override render()
    {
        return (
            <InferenceLayout<MemoryRow, MemoryInputRow>
                {...this.props}
                action={{ description: this.props.isEdit ? InferenceInfo.memory.edit : InferenceInfo.memory.create }}
                pages={{
                    entity: InferenceEntities.memory(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): MemoryInputRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let { wiper_id } = this.InferencerCommonFields_Ids.current?.getValue() ?? InferencerCommonFields.EMPTY;
                                        let description = this.NSBoxString_Description.current?.getValue() ?? null;
                                        return {
                                            workspace_id: null,
                                            name,
                                            wiper_id,
                                            description,
                                            memory_category: [],
                                            memory_field: [],
                                            memory_tag: [],
                                        };
                                    },
                                    setRow: (row: MemoryRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.InferencerCommonFields_Ids.current?.setValue({
                                            wiper_id: row.wiper_id,
                                        });
                                        this.NSBoxString_Description.current?.setValue(row.description);
                                    }
                                },
                                ui: {
                                    extra_tabs: [
                                        {
                                            title: "Common",
                                            clicked: true,
                                            getContent: () => (
                                                <InferencerCommonFields
                                                    ref={this.InferencerCommonFields_Ids}
                                                    {...this.props}
                                                    hide={{ validator: true, budget: true, memory: true, log_group: true }}
                                                    info_entity="memory"
                                                />
                                            ),
                                        },
                                    ]
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/memory/#field-name" }}
                    />
                    <NSBoxString
                        ref={this.NSBoxString_Description}
                        required={false}
                        title="Description"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/memory/#field-description" }}
                    />
                </NSColumn>
            </InferenceLayout>
        );
    }
}